module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-CondensedThinItalic.094394b.woff2";